import { useQuery } from 'react-query';

import { getCacheSettings } from 'common/helpers';
import { ISelectModel } from 'common/models';
import API from 'services/api';

const ROOT_PLACES_OF_PAYMENT = 'ROOT_PLACES_OF_PAYMENT';

// TODO: move out from root, because it is not root
const getPlacesOfPayment = (): Promise<ISelectModel<number>[]> =>
  API.get('/api/payment-source').then(response => response.data);

export const usePlacesOfPaymentQuery = () => {
  const { data: placesOfPayment, ...rest } = useQuery(
    ROOT_PLACES_OF_PAYMENT,
    getPlacesOfPayment,
    getCacheSettings(),
  );

  return {
    ...rest,
    placesOfPayment,
  };
};
